import { defineMessages } from 'react-intl';

/** The copy of Contacts, the contact drawer and the import (design outreach-v2 k1, outreach q2 to q6). */
export const contactsMessages = defineMessages({
  title: { id: 'app.outreach.contacts.title', defaultMessage: 'Contacts' },
  intro: {
    id: 'app.outreach.contacts.intro',
    defaultMessage:
      'Each person Plug pitched for you, with what they did. Add your own contacts too: Plug pitches them first.',
  },
  importCsv: { id: 'app.outreach.contacts.import', defaultMessage: 'Import CSV' },
  exportCsv: { id: 'app.outreach.contacts.export', defaultMessage: 'Export CSV' },
  exportLock: { id: 'app.outreach.contacts.exportLock', defaultMessage: 'On Pro' },

  chipAll: { id: 'app.outreach.contacts.filter.all', defaultMessage: 'All' },
  chipReplied: { id: 'app.outreach.contacts.filter.replied', defaultMessage: 'Replied' },
  chipPlaced: { id: 'app.outreach.contacts.filter.addedSong', defaultMessage: 'Added a song' },
  chipImported: { id: 'app.outreach.contacts.filter.imported', defaultMessage: 'Your imports' },
  chipNeverContact: { id: 'app.outreach.contacts.filter.neverContact', defaultMessage: 'Never contact' },
  kindFilter: { id: 'app.outreach.contacts.filter.kind', defaultMessage: 'Kind of person' },
  allKinds: { id: 'app.outreach.contacts.filter.allKinds', defaultMessage: 'All kinds' },
  listsTitle: { id: 'app.outreach.contacts.lists', defaultMessage: 'Lists' },
  deleteList: { id: 'app.outreach.contacts.lists.delete', defaultMessage: 'Delete the list {name}' },
  deleteListConfirm: {
    id: 'app.outreach.contacts.lists.deleteConfirm',
    defaultMessage: 'Delete the list "{name}"? The contacts stay in your workspace.',
  },
  search: { id: 'app.outreach.contacts.search', defaultMessage: 'Search name, outlet, email' },
  tagFilter: { id: 'app.outreach.contacts.tagFilter', defaultMessage: 'Tag' },
  count: {
    id: 'app.outreach.contacts.count',
    defaultMessage: '{count, plural, one {# contact} other {# contacts}} · sorted by last activity',
  },

  colName: { id: 'app.outreach.contacts.col.who', defaultMessage: 'Who' },
  colEmail: { id: 'app.outreach.contacts.col.email', defaultMessage: 'Email' },
  colStatus: { id: 'app.outreach.contacts.col.lastResult', defaultMessage: 'Last result' },
  colLastPitched: { id: 'app.outreach.contacts.col.lastPitched', defaultMessage: 'Last pitched' },
  never: { id: 'app.outreach.contacts.notPitched', defaultMessage: 'Not pitched yet' },
  importedKind: { id: 'app.outreach.contacts.importedKind', defaultMessage: 'Your import · {kind}' },
  importedOnly: { id: 'app.outreach.contacts.importedOnly', defaultMessage: 'Your import' },
  // An import that waits: it goes to the front of the next batch of a running campaign.
  firstInLine: { id: 'app.outreach.contacts.firstInLine', defaultMessage: 'First in line' },

  emptyTitle: { id: 'app.outreach.contacts.empty.title', defaultMessage: 'No contacts yet' },
  emptyBody: {
    id: 'app.outreach.contacts.empty.body',
    defaultMessage:
      'A person shows here after Plug pitches them. Import your own contacts too: Plug pitches them first.',
  },
  emptyFind: { id: 'app.outreach.contacts.empty.find', defaultMessage: 'Find who fits you' },
  noMatch: { id: 'app.outreach.contacts.noMatch', defaultMessage: 'No contacts match these filters' },
  clearFilters: { id: 'app.outreach.contacts.clearFilters', defaultMessage: 'Clear filters' },

  bulkMeta: {
    id: 'app.outreach.contacts.bulk.meta',
    defaultMessage: '{withEmail} with an email · {without} with no email (cannot join a campaign)',
  },
  tag: { id: 'app.outreach.contacts.bulk.tag', defaultMessage: 'Tag' },
  tagPrompt: { id: 'app.outreach.contacts.bulk.tagPrompt', defaultMessage: 'The tag to add' },

  // q2 drawer
  drawerKind: { id: 'app.outreach.contact.kind', defaultMessage: '{kind} · {region}' },
  pointsTitle: { id: 'app.outreach.contact.points', defaultMessage: 'Contact points' },
  targetsTitle: { id: 'app.outreach.contact.targets', defaultMessage: 'Targets' },
  historyTitle: { id: 'app.outreach.contact.history', defaultMessage: 'Pitch history · all campaigns' },
  historyRow: { id: 'app.outreach.contact.historyRow', defaultMessage: 'Sent {date}' },
  historyNone: { id: 'app.outreach.contact.historyNone', defaultMessage: 'Not pitched yet.' },
  notesTitle: { id: 'app.outreach.contact.notes', defaultMessage: 'Notes · your workspace only' },
  tagsTitle: { id: 'app.outreach.contact.tags', defaultMessage: 'Tags' },
  addTag: { id: 'app.outreach.contact.addTag', defaultMessage: '+ Tag' },
  setDoNotContact: { id: 'app.outreach.contact.doNotContact', defaultMessage: 'Do not contact' },
  allowContact: { id: 'app.outreach.contact.allow', defaultMessage: 'Allow pitches again' },
  stoppedByRecipient: {
    id: 'app.outreach.contact.stoppedByRecipient',
    defaultMessage: 'This person asked to get no more pitches. You cannot pitch them again.',
  },
  doNotContactNote: {
    id: 'app.outreach.contact.doNotContactNote',
    defaultMessage:
      '"Do not contact" stops every pitch from this workspace to this person, in all campaigns. Other MUSIC24 users can still pitch them. When a person opts out themselves, nobody on MUSIC24 can.',
  },
  doNotContactConfirm: {
    id: 'app.outreach.contact.doNotContactConfirm',
    defaultMessage: 'Stop every pitch from this workspace to {name}?',
  },
  networkLine: {
    id: 'app.outreach.contact.networkLine',
    defaultMessage: 'Your workspace sends a person at most {cap} pitches a week.',
  },
  noEmailNote: {
    id: 'app.outreach.contact.noEmail',
    defaultMessage: 'No email: this contact cannot join a campaign. Use their public links.',
  },

  // q3 import
  importTitle: { id: 'app.outreach.import.title', defaultMessage: 'Import contacts' },
  stepFile: { id: 'app.outreach.import.step.file', defaultMessage: '1 File' },
  stepColumns: { id: 'app.outreach.import.step.columns', defaultMessage: '2 Columns' },
  stepCheck: { id: 'app.outreach.import.step.check', defaultMessage: '3 Check' },
  fileBody: {
    id: 'app.outreach.import.file.body',
    defaultMessage: 'A CSV file with a header row and one person a row. The Email column is required. Max {max} rows.',
  },
  fileLabel: { id: 'app.outreach.import.file.label', defaultMessage: 'Choose a CSV file' },
  badFile: {
    id: 'app.outreach.import.file.bad',
    defaultMessage: 'We could not read this file. Save it as CSV and try again.',
  },
  tooLarge: {
    id: 'app.outreach.import.file.tooLarge',
    defaultMessage: 'This file has more than {max} rows. Split it and import the parts.',
  },
  columnsBody: {
    id: 'app.outreach.import.columns.body',
    defaultMessage: '{file} · {count, plural, one {# row} other {# rows}}. Tell us what each column holds.',
  },
  colYours: { id: 'app.outreach.import.col.yours', defaultMessage: 'Your column' },
  colField: { id: 'app.outreach.import.col.field', defaultMessage: 'MUSIC24 field' },
  colSample: { id: 'app.outreach.import.col.sample', defaultMessage: 'First row' },
  fieldName: { id: 'app.outreach.import.field.name', defaultMessage: 'Name' },
  fieldEmail: { id: 'app.outreach.import.field.email', defaultMessage: 'Email' },
  fieldKind: { id: 'app.outreach.import.field.kind', defaultMessage: 'Kind (press, playlist, radio)' },
  fieldUrl: { id: 'app.outreach.import.field.url', defaultMessage: 'Link' },
  fieldTags: { id: 'app.outreach.import.field.tags', defaultMessage: 'Tags' },
  fieldSkip: { id: 'app.outreach.import.field.skip', defaultMessage: 'Skip this column' },
  noEmailColumn: { id: 'app.outreach.import.noEmailColumn', defaultMessage: 'Pick the column that holds the email.' },
  checkBody: {
    id: 'app.outreach.import.check.body',
    defaultMessage:
      '{ready, plural, one {# row is} other {# rows are}} ready. {noEmail, plural, =0 {} one {# row has no email; we skip it.} other {# rows have no email; we skip them.}} Addresses on the MUSIC24 stop list are skipped too.',
  },
  consent: { id: 'app.outreach.import.consent', defaultMessage: 'I may contact these people' },
  consentBody: {
    id: 'app.outreach.import.consentBody',
    defaultMessage:
      'They are business contacts (curators, press, radio) that I know or that published their address for submissions. Imported addresses stay in my workspace and never go into the MUSIC24 directory.',
  },
  addToList: { id: 'app.outreach.import.addToList', defaultMessage: 'Add to list' },
  noList: { id: 'app.outreach.import.noList', defaultMessage: 'No list' },
  tagAll: { id: 'app.outreach.import.tagAll', defaultMessage: 'Tag every row (optional)' },
  importsFirst: {
    id: 'app.outreach.import.firstInLine',
    defaultMessage:
      "Plug pitches your imports first, in the next day's batch of a running campaign. They count in your pitches a day.",
  },
  back: { id: 'app.outreach.import.back', defaultMessage: 'Back' },
  next: { id: 'app.outreach.import.next', defaultMessage: 'Next' },
  importButton: {
    id: 'app.outreach.import.button',
    defaultMessage: 'Import {count, plural, one {# contact} other {# contacts}}',
  },
  done: {
    id: 'app.outreach.import.done',
    defaultMessage:
      '{created, plural, one {# contact} other {# contacts}} imported. {skipped} skipped, {suppressed} on the stop list.',
  },
  failed: { id: 'app.outreach.import.failed', defaultMessage: 'The import failed. Nothing was imported. Try again.' },
});
